import LookUp from './lookup'
export default class SubdivisionType extends LookUp{}